import { Flex, Grid, GridItem, Text, Image } from '@chakra-ui/react';
import { MdAirplanemodeActive, MdKingBed, MdOutlineTrain } from 'react-icons/md';

type TripBoxProps = {
  data: {
    images: string[];
    title: string;
    airplane: number;
    beds: number;
    train: number;
    dates: string;
  };
};

const TripBox = ({ data }: TripBoxProps) => {
  return (
    <Flex boxShadow="3px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 20px -5px rgba(151, 151, 151, 0.04)" align='center' borderRadius='25px' marginBottom={4}>
        <Grid w="350px" h="200px" templateRows='repeat(4, 1fr)' paddingTop={7}
            templateColumns='repeat(3, 1fr)' gap={1} marginRight={10}>
            <GridItem rowSpan={2} colSpan={2}> 
                <Image borderRadius="25px 0px 0px 25px" src={data.images[0]} alt='First image' />
            </GridItem>
            <GridItem colSpan={1} >
                <Image borderRadius="0px 25px 0px 0px" src={data.images[1]} alt='Second image' />
            </GridItem>
            <GridItem colSpan={1}>
            <Image borderRadius="0px 0px 25px 0px" src={data.images[2]} alt='Third image' />
            </GridItem>
        </Grid>
        <Flex align='flex-start' flexDirection="column">
            <Text fontSize="20px" fontFamily="Montserrat" fontWeight={600}>
                {data.title}
            </Text>
            <Text fontSize="17px" color='#6F6F6F' fontWeight={400}>
                {data.dates}
            </Text>
            <Flex align='center' marginTop={5} >
                <MdAirplanemodeActive />
                <Text fontSize="17px" marginLeft={3} marginRight={3} color='#6F6F6F' fontWeight={400}>
                    {data.airplane}
                </Text>
                <MdKingBed />
                <Text fontSize="17px" marginLeft={3} marginRight={3} color='#6F6F6F' fontWeight={400}>
                    {data.beds}
                </Text>
                <MdOutlineTrain />
                <Text fontSize="17px" marginLeft={3} color='#6F6F6F' fontWeight={400}>
                    {data.train}
                </Text>
            </Flex>
        </Flex>
    </Flex>
  );
};

export { TripBox };
